import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Card, IconButton,  CardHeader, Menu, MenuItem, CardContent, CardActions, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@material-ui/core";
import "./style.css";
import c3 from "c3";
import "c3/c3.min.css";
import _ from "lodash";
import { Responsive, WidthProvider } from "react-grid-layout";
import {MoreVert } from "@material-ui/icons";

const ResponsiveReactGridLayout = WidthProvider(Responsive);

const useStyles = makeStyles({
  table: {
    minWidth: 500,
  },
});
function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const rows = [
  createData("Frozen yoghurt", 159, 6.0, 24, 4.0),
  createData("Ice cream sandwich", 237, 9.0, 37, 4.3),
  createData("Eclair", 262, 16.0, 24, 6.0),
  createData("Cupcake", 305, 3.7, 67, 4.3),
  createData("Gingerbread", 356, 16.0, 49, 3.9),
];
let gaugeChartJson = {
  bindto: "#chart2",
  data: {
    columns: [["data", 91.4]],
    type: "gauge",
    // onclick: function (d, i) {
    //   console.log("onclick", d, i);
    // },
    // onmouseover: function (d, i) {
    //   console.log("onmouseover", d, i);
    // },
    // onmouseout: function (d, i) {
    //   console.log("onmouseout", d, i);
    // },
  },
  gauge: {
    label: {
      format: function (value, ratio) {
        return value;
      },
      show: false // to turn off the min/max labels.
    },
    min: 0, // 0 is default, //can handle negative min e.g. vacuum / voltage / current flow / rate of change
    max: 100, // 100 is default
    units: ' %',
    width: 59 // for adjusting arc thickness
  },
  color: {
    pattern: ["#FF0000", "#F97600", "#F6C600", "#60B044"], // the three color levels for the percentage values.
    threshold: {
      unit: 'value', // percentage is default
      max: 200, // 100 is default
      values: [30, 60, 90, 100],
    },
  },
  size: {
    height: 180,
  },
};
let pieChartJson = {
  bindto: "#chart1",
  data: {
    // iris data from R
    columns: [
      ["data1", 30],
      ["data2", 120],
    ],
    type: "pie",
    // onclick: function (d, i) {
    //   console.log("onclick", d, i);
    // },
    // onmouseover: function (d, i) {
    //   console.log("onmouseover", d, i);
    // },
    // onmouseout: function (d, i) {
    //   console.log("onmouseout", d, i);
    // },
  },
};
let chartJson = {
  bindto: "#chart0",
  data: {
    columns: [
      ["data1", 30, 200, 100, 400, 150, 250],
      ["data2", 130, 100, 140, 200, 150, 50],
    ],
    type: "bar",
  },
  bar: {
    width: {
      ratio: 0.5, // this makes bar width 50% of length between ticks
    },
    // or
    //width: 100 // this makes bar width 100px
  },
}
const ShowcaseLayout = () => {
  const [layoutJson] = useState([
    { i: "0", x: 0, y: 2, w: 2, h: 2, data: [1, 2, 3] },
    { i: "1", x: 2, y: 2, w: 2, h: 2 },
    { i: "2", x: 4, y: 2, w: 2, h: 2 },
    { i: "3", x: 6, y: 2, w: 2, h: 2 },
    { i: "4", x: 0, y: 2, w: 2, h: 2 },
  ]);
  const [currentState] = useState({
    currentBreakpoint: "lg",
    compactType: "vertical",
    mounted: false,
    layouts: { lg: layoutJson }
  });
  const [currentBreakpoint, setCurrentBreakpoint] = useState("lg");
  const [compactType, setCompactType] = useState("vertical");
  const [mounted] = useState(false);
  const [layouts, setLayouts] = useState({ lg: layoutJson });

  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  // const dispatch = useDispatch();
  const history = useHistory();

  // const config = useSelector((state) => state.config);

  const { isAuthenticated } = useSelector((state) => state.auth);


  useEffect(() => {
    c3.generate(chartJson);
    c3.generate(pieChartJson);
    c3.generate(gaugeChartJson);
    //console.log("layout", JSON.parse(layout()));
  }, []);

  if (!isAuthenticated) {
    history.push("/");
    return;
  }

  const editDashlet = (data) => {
    console.log("Edit")
    console.log(data)
    // let newLayout = layout.filter((item) => { return item.i !== data.i });
  }
  const refreshDashlet = (data) => {
    console.log("Refresh")
    console.log(data)
    // let newLayout = layout.filter((item) => { return item.i !== data.i });
  }
  const removeDashlet = (data) => {
    console.log("Remove")
    console.log(data)
    // let newLayout = layout.filter((item) => { return item.i !== data.i });
  }


  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const generateDOM = () => {
    return _.map(layouts.lg, function (l, i) {
      return (

        <Card className={classes.root} key={i}>
          <CardHeader
            avatar={
              <i
                className={"fas fas fa-cube fa-1x"}


              ></i>
            }
            action={
              <>
                <IconButton
                  aria-label="settings"
                  style={{ color: "#fff" }}
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                >
                  <MoreVert />
                </IconButton>

                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  <MenuItem onClick={() => editDashlet()}>Edit</MenuItem>
                  <MenuItem onClick={() => refreshDashlet()}>Refresh</MenuItem>
                  <MenuItem onClick={() => removeDashlet()}>Remove</MenuItem>
                </Menu>
              </>
            }
            title="Dashlet"
            // subheader="September 14, 2016"
            style={{
              backgroundColor: "#040c2c",
              color: "#fff",
              fontSize: "1.2rem",
              fontWeight: "bold",
              padding: "5px 10px"
            }}
          />

          <CardContent>
            {/* <Button onClick={() => removeGrid(data)}>X</Button> */}
            {i === 0 ? (
              <div id={"chart" + i}></div>
            ) : (
                <>
                  <div id={"chart" + i}></div>
                  <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Dessert (100g serving)</TableCell>
                          <TableCell align="right">Calories</TableCell>
                          <TableCell align="right">Fat&nbsp;(g)</TableCell>
                          <TableCell align="right">Carbs&nbsp;(g)</TableCell>
                          <TableCell align="right">Protein&nbsp;(g)</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows.map((row) => (
                          <TableRow key={row.name}>
                            <TableCell component="th" scope="row">
                              {row.name}
                            </TableCell>
                            <TableCell align="right">{row.calories}</TableCell>
                            <TableCell align="right">{row.fat}</TableCell>
                            <TableCell align="right">{row.carbs}</TableCell>
                            <TableCell align="right">{row.protein}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              )}
          </CardContent>
          <CardActions>
            <Button size="small">Learn More</Button>
          </CardActions>
        </Card>


      );
    });
  }

  const onBreakpointChange = (breakpoint) => {
    setCurrentBreakpoint(breakpoint);

  }

  const onCompactTypeChange = () => {
    const { compactType: oldCompactType } = currentState;
    const compactType =
      oldCompactType === "horizontal"
        ? "vertical"
        : oldCompactType === "vertical"
          ? null
          : "horizontal";
    setCompactType(compactType);
  }

  const onLayoutChange = (layout, layouts) => {
    // console.log("layout============>")
    // console.log(layout)
    // console.log(layouts)
    // setLayouts(layouts);
  }

  const onNewLayout = () => {

    setLayouts({ lg: layoutJson });

  }
  const onAddItem = () => {

    let newDashlet = {
      i: '' + layoutJson.length + '',
      x: 0,
      y: 2, // puts it at the bottom
      w: 2,
      h: 2
    };
    layoutJson.unshift(newDashlet);
    setLayouts({ lg: layoutJson })
    console.log(layoutJson)
  }
  return (
    <div>
      <div>
        Current Breakpoint:
         {/* {currentBreakpoint} ({
          // this.props.cols[currentBreakpoint]
        }{" "}
        columns) */}
      </div>
      <div>
        Compaction type:{" "}
        {_.capitalize(compactType) || "No Compaction"}
      </div>
      <button onClick={onAddItem}>Add Dashlet</button>
      <button onClick={onNewLayout}>Generate New Layout</button>
      <button onClick={onCompactTypeChange}>
        Change Compaction Type
        </button>
      <ResponsiveReactGridLayout
        // {...this.props}
        className="layout"
        breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
        cols={{ lg: 8, md: 8, sm: 6, xs: 4, xxs: 2 }}
        layouts={layouts}
        onBreakpointChange={onBreakpointChange}
        onLayoutChange={onLayoutChange}
        // WidthProvider option
        measureBeforeMount={false}
        // I like to have it animate on mount. If you don't, delete `useCSSTransforms` (it's default `true`)
        // and set `measureBeforeMount={true}`.
        useCSSTransforms={mounted}
        compactType={compactType}
        preventCollision={!compactType}
        // rowWidth={200}
        // rowHeight={200}
        // width={1200}
        margin={[10, 20]}

      >
        {generateDOM()}
      </ResponsiveReactGridLayout>
    </div>
  );
}

// ShowcaseLayout.propTypes = {
//   onLayoutChange: PropTypes.func.isRequired
// };

// ShowcaseLayout.defaultProps = {
//   className: "layout",
//   rowHeight: 30,
//   onLayoutChange: function () { },
//   cols: { lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 },
//   // initialLayout: generateLayout()
// };

// const generateLayout = () => {
//   var x = 0;
//   return _.map(_.range(0, 25), function (item, i) {
//     var y = Math.ceil(Math.random() * 4) + 1;
//     x = x > 3 ? 0 : x;
//     var xAxis = x++ * 2;
//     return {
//       x: xAxis,//(_.random(0, 5) * 2) % 12,
//       y: 2,//Math.floor(i / 6) * y,
//       w: 2,
//       h: 2,
//       i: i.toString(),
//       // minW: 2,
//       // minH: 2,
//       // maxH: 4,
//       // static: Math.random() < 0.05
//     };
//   });
// }

export default ShowcaseLayout;
